import { render } from "./EasterEggDecorate.vue?vue&type=template&id=4340d823"
import script from "./EasterEggDecorate.vue?vue&type=script&lang=js"
export * from "./EasterEggDecorate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__